module.exports = __webpack_public_path__ + "static/media/ghost.1d29ec15.png";